import React, { RefObject, ReactNode } from 'react';

import { FileInput, Tooltip } from '@trqk/components';

import { PROStatementHelp } from '../../../tooltips';

interface Props {
    children: ReactNode;
    handleUploadViaLink(fileInput: RefObject<HTMLInputElement>): void;
    handleSelectedFilesWithWrongType(): void;
}

export const ErrorMessage = ({
    children,
    handleUploadViaLink,
    handleSelectedFilesWithWrongType,
}: Props): JSX.Element => (
        <>
            <div className="border-l-4 border-solid border-quinary-400 rounded-full" />
            <div className="ml-12">
                {children}
                <div className="flex">
                    <div>Drag & Drop a new file or&nbsp;</div>
                    <FileInput
                        addClasses="flex-grow"
                        acceptMultiple={false}
                        acceptFileTypes={['csv']}
                        handleSelectedFilesWithWrongType={
                            handleSelectedFilesWithWrongType
                        }
                        inputId="landing-page-csv-upload"
                        // We could actually handle multiple files here if we choose,
                        // but it's currently set up for a single file upload.
                        // acceptMultiple={true}
                        handleFiles={handleUploadViaLink}
                    >
                        <span className="font-semibold respond-to-mouse text-white underline">
                            browse.
                        </span>
                    </FileInput>
                </div>
                <div className="mt-10">
                    <Tooltip
                        addClasses="respond-to-mouse text-black"
                        messageClasses="respond-to-mouse"
                        background="light"
                        maxWidth={600}
                        minWidth={600}
                        RenderMessage={PROStatementHelp}
                        position="right"
                    >
                        <span className="text-white font-semibold border-dashed border-b-2 border-white">
                            How do I get a .csv of my statement?
                        </span>
                    </Tooltip>
                </div>
            </div>
        </>
    );
